/* global axios */
import ApiClient from '../ApiClient';

// T-153b: convite de retomada por e-mail. Contato ativo do clube, só administrador.
class RetomadaAPI extends ApiClient {
  constructor() {
    super('fandata/conversations', { accountScoped: true });
  }

  enviar(conversationId) {
    return axios.post(`${this.url}/${conversationId}/retomada`);
  }
}

export default new RetomadaAPI();
